import React from 'react';
import PropTypes from 'prop-types';

import SVGMeter from 'assets/images/VGMeter.svg';
import { formatNumberWithCommas } from 'components/helpers';
import useShowDataLogic from 'hooks/useShowDataLogic';
import NoEstimateData from 'components/EstimateScale/NoEstimateData';

import {
  Container, EstimateTitle, EstimateTitleDesktop, Wrapper, EstimateValueWrapper, EstimateValue, ValueMeterWrapper, ValueMeter, UpperValue, LowerValue,
} from './styles';

const EstimateScale = ({ estimate }) => {
  const { showData, showDataMessage } = useShowDataLogic();

  if (!showData) {
    return <NoEstimateData message={showDataMessage} />
  }

  return (
    <Container>
      <Wrapper>
        <EstimateValueWrapper>
          <EstimateTitle>Estimated Value</EstimateTitle>
          <EstimateValue>
            {`$${formatNumberWithCommas(estimate.prediction)}`}
          </EstimateValue>
        </EstimateValueWrapper>

        <ValueMeterWrapper>
          <ValueMeter src={SVGMeter} />
          <UpperValue>{`$${formatNumberWithCommas(estimate.predictionHigh)}`}</UpperValue>
          <LowerValue>{`$${formatNumberWithCommas(estimate.predictionLow)}`}</LowerValue>
        </ValueMeterWrapper>
      </Wrapper>
    </Container>
  );
};

EstimateScale.propTypes = {
  estimate: PropTypes.number.isRequired,
};

export default EstimateScale;
